import { createContext, createElement, useCallback, useContext, useState } from "react";

const dict = {
  it: {
    app_name: "Kart Setup & Data Analisys by RacingDreams",
    claim: "Setup, Pressioni, Analisi Dati",
    tagline: "Tutto ciò che ti serve per migliorare ogni giorno nel Motorsport in un'unica app nata dalla nostra pluriennale esperienza nei campionati FIA Karting.",
    nav_events: "Eventi",
    nav_garage: "Garage",
    g_laps: "Giri totali",
    tyre_brand: "Marca gomma",
    tyre_model: "Modello / mescola",
    tyre_target: "Target uscita",
    tyre_unknown: "Gomma non indicata",
    tyre_targets: "Target pressioni in uscita",
    tyre_targets_hint: "Pressione a caldo da raggiungere in uscita per marca e modello gomma (in bar). La tolleranza definisce la fascia 'in target'.",
    default_channels: "Grafici telemetria di default",
    default_channels_hint: "Canali mostrati all'apertura dell'analisi telemetria. Puoi sempre attivarne o disattivarne altri dall'analisi. Nessuna selezione = velocità e RPM.",
    no_channels_yet: "Importa una telemetria per vedere i canali disponibili.",
    target_bar: "Target (bar)",
    tolerance_bar: "Toll. ± (bar)",
    add_target: "Aggiungi gomma",
    no_target: "Nessun target per questa gomma: indica marca e modello e impostane il target in Impostazioni.",
    no_target_short: "Target non impostato",
    tyre_from_set: "Dal treno gomme",
    tyre_from_set_hint: "Marca e modello presi dal treno selezionato: per cambiarli modifica il treno in garage o scegli Nessuno",
    p_ok: "In target",
    p_high: "Alta",
    p_low: "Bassa",
    p_mixed: "Mista",
    p_na: "—",
    p_na_hot: "Manca caldo",
    pa_title: "Analisi pressioni",
    pa_next: "Consigli per la sessione successiva",
    pa_exp_temp: "Asfalto previsto (°C)",
    pa_cold_next: "Freddo consigliato",
    pa_delta: "Δ target",
    pa_gain: "Aumento",
    pa_based: "Correzione temperatura dallo storico ({n} stint stessa pista e gomma, in media {s}/°C).",
    calc_air_ignored: "La temperatura aria non influisce: le sessioni non hanno abbastanza variazione di aria.",
    calc_track_ignored: "La temperatura asfalto non influisce: le sessioni non hanno abbastanza variazione di asfalto.",
    calc_temps_ignored: "Temperature non influenti: troppe poche sessioni o condizioni simili, uso la media.",
    pa_no_hist: "Storico insufficiente per stimare l'effetto della temperatura asfalto: il consiglio usa l'aumento freddo→caldo di questa sessione.",
    tip_all_ok: "Tutte le ruote in target: con condizioni simili ripeti le stesse pressioni a freddo.",
    tip_wheel: "{w}: in uscita {d} {u} rispetto al target → a freddo {c} {u}.",
    tip_axle_front: "Anteriori più alte delle posteriori di {d} {u} in uscita: correggi gli assi separatamente.",
    tip_axle_rear: "Posteriori più alte delle anteriori di {d} {u} in uscita: correggi gli assi separatamente.",
    tip_side_left: "Lato sinistro più alto del destro di {d} {u}: tipico con prevalenza di curve a destra, regola le singole ruote.",
    tip_side_right: "Lato destro più alto del sinistro di {d} {u}: tipico con prevalenza di curve a sinistra, regola le singole ruote.",
    tip_temp: "Consigli calcolati per asfalto a {t}°C ({d}°C rispetto a questa sessione).",
    tip_missing_hot: "Inserisci le pressioni a caldo in uscita per ottenere analisi e consigli.",
    tyre_model_filter: "Gomma",
    all_tyre_models: "Tutte le gomme (marca)",
    hot_vs_target: "Pressione in uscita vs target",
    gain_chart: "Aumento freddo → caldo vs {x}",
    calc_title: "Calcolatore pressioni a freddo",
    calc_hint: "Freddo consigliato = target − aumento previsto alla temperatura asfalto indicata (regressione sugli stint filtrati; servono almeno 3 stint con 4°C di escursione, altrimenti media).",
    calc_need_model: "Seleziona una gomma con target impostato per usare il calcolatore.",
    pick_model_note: "Gomme diverse nei dati: seleziona una gomma per vedere la fascia target.",
    in_target_rate: "Stint in target",
    avg_delta: "Δ medio",
    status: "Stato",
    avg_delta_wheel: "Δ medio rispetto al target per ruota",
    sec_summary: "Riepilogo",
    sec_charts: "Grafici",
    impact_title: "Influenza delle condizioni",
    impact_hint: "Quanto cambia in media il guadagno a caldo (caldo − freddo, media delle 4 gomme) al variare di ogni condizione, sulle sessioni filtrate. Clicca una card per usarla come asse X dei grafici.",
    impact_per: "guadagno ogni +{s}",
    impact_strong: "Influenza forte",
    impact_moderate: "Influenza moderata",
    impact_weak: "Influenza debole",
    impact_none: "Trascurabile",
    impact_few: "Dati insufficienti (n={n}, servono almeno 3 sessioni)",
    impact_flat: "Valore sempre uguale nelle sessioni filtrate",
    sec_sessions: "Sessioni analizzate",
    calc_scope: "Base di calcolo",
    analysis_period: "Periodo di analisi (obbligatorio)",
    days_filter: "Giorni",
    all_days: "Tutti i giorni dell'evento",
    days_selected: "giorni selezionati",
    pick_event: "Seleziona evento…",
    need_event: "Seleziona almeno un evento (e se vuoi i giorni) per circoscrivere il periodo di analisi.",
    calc_basis: "Calcolo basato sulle {n} sessioni del periodo selezionato (eventi/giorni nei filtri).",
    calc_scope_all: "Tutto lo storico filtrato",
    calc_scope_event: "Stesso evento",
    calc_scope_day: "Stesso evento e giorno",
    calc_day: "Giorno",
    air_temp_short: "Aria attuale (°C)",
    track_temp_short: "Asfalto attuale (°C)",
    calc_no_data: "Nessuna sessione con pressioni a freddo e a caldo per questa selezione.",
    calc_model: "Modello",
    model_both: "Regressione aria + asfalto",
    model_track: "Regressione su asfalto",
    model_air: "Regressione su aria",
    model_mean: "Media aumento freddo→caldo",
    calc_hint2: "Freddo consigliato = target − aumento previsto con le temperature indicate, stimato dalle sessioni selezionate (servono almeno 3-4 sessioni con temperature diverse per la regressione, altrimenti media).",
    calc_used: "Sessioni usate (aria / asfalto)",
    vs_last: "vs ultima",
    lapfile_add: "Aggiungi file giri",
    lapfile_replace: "Sostituisci file giri",
    lapfile_hint: "Aggiungi il file giri (CSV con tempi e settori) per calcolare il giro teorico e i settori.",
    lapfile_done: "File giri importato: settori e teorico aggiornati.",
    lapfile_no_sectors: "nessun settore nel file",
    lapfile_match: "{m}/{n} giri coerenti con la telemetria.",
    lapfile_force: "Importa comunque",
    qi_btn: "Importazione rapida",
    qi_title: "Importazione rapida telemetrie",
    qi_base: "Nome sessioni",
    qi_base_hint: "Le sessioni saranno create come {n}1, {n}2, … in ordine di data e ora della telemetria.",
    qi_pick: "Seleziona uno o più file CSV di telemetria",
    qi_files: "file selezionati · clic per cambiare",
    qi_run: "Importa e crea sessioni",
    qi_created: "sessioni create",
    qi_close: "Chiudi",
    all_events: "Tutti gli eventi",
    events_filter: "Evento / Eventi",
    events_selected: "eventi selezionati",
    gmaps_link: "Crea da Google Maps",
    gmaps_import: "Importa",
    gmaps_done: "Posizione importata da Google Maps",
    gmaps_hint: "Su Google Maps: Condividi → Copia link, oppure tasto destro sulla pista → clic sulle coordinate per copiarle.",
    g_sessions: "Sessioni",
    g_events: "Eventi",
    g_last_used: "Ultimo uso",
    g_laps_reset: "Giri da reset",
    g_hours: "Ore motore",
    logout: "Esci",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    name: "Nome",
    sign_in: "Entra",
    create_account: "Crea account",
    or: "oppure",
    google: "Continua con Google",
    loading: "Caricamento...",
    events_title: "Calendario eventi",
    events_sub: "Le tue gare in ordine di calendario",
    new_event: "Nuovo evento",
    edit_event: "Modifica evento",
    search_name: "Cerca per nome evento",
    track: "Pista",
    event_type: "Tipologia",
    all_types: "Tutte le tipologie",
    date_from: "Dal",
    date_to: "Al",
    reset_filters: "Azzera filtri",
    order_asc: "Più vecchi prima",
    order_desc: "Più recenti prima",
    no_events: "Nessun evento trovato. Crea il tuo primo evento.",
    sessions_count: "sessioni",
    laps_per_driver: "Giri per pilota",
    hour_meter: "Ultima lettura contaore (h)",
    hour_meter_date: "Data lettura",
    carburetor: "Carburatore installato",
    ignition: "Accensione installata",
    engine_setup: "Setup motore (note)",
    maintenance: "Manutenzioni",
    maintenance_short: "manutenzioni",
    add_maintenance: "Aggiungi",
    no_maintenance: "Nessuna manutenzione registrata",
    activity: "Attività svolta",
    cost_eur: "Costo €",
    reset_hours: "Reset contaore",
    last_reset: "ultimo reset",
    event_best: "Best evento",
    total: "Totale",
    country: "Nazione",
    category: "Categoria",
    category_hint: "es. OK, KZ2, X30 Senior",
    event_name: "Nome evento",
    start_date: "Data inizio",
    end_date: "Data fine",
    notes: "Note",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    duplicate: "Duplica",
    back: "Indietro",
    confirm_title: "Confermi l'eliminazione?",
    confirm_event: "L'evento e tutte le sue sessioni verranno eliminati definitivamente.",
    confirm_generic: "L'elemento verrà eliminato definitivamente.",
    saved: "Salvato",
    deleted: "Eliminato",
    sessions: "Sessioni",
    new_session: "Nuova sessione",
    edit_session: "Modifica sessione",
    no_sessions: "Nessuna sessione registrata per questo evento.",
    session_name: "Nome sessione",
    session_name_hint: "es. Prove libere 1, Qualifica, Finale",
    session_date: "Data sessione",
    session_time: "Ora",
    best_lap: "Miglior tempo",
    best_lap_hint: "es. 48.235 o 1:02.481",
    event_best: "Miglior tempo evento",
    chassis: "Telaio",
    engine: "Motore",
    none: "Nessuno",
    general: "Generale",
    nav_tyres: "Gomme",
    telemetry: "Telemetria",
    telemetry_hint: "Carica il CSV di sessione esportato da MAAT (Strumenti → Esporta CSV → Sessione intera).",
    telemetry_save_first: "Premi Salva: la sessione viene creata e resti qui per importare subito la telemetria.",
    session_created_telemetry: "Sessione creata: ora puoi importare la telemetria",
    telemetry_imported: "Telemetria importata",
    telemetry_imported_laps: "Telemetria importata: tab Giri, miglior tempo e n° giri generati automaticamente.",
    import_telemetry: "Importa telemetria",
    processing: "Elaborazione...",
    channels: "Canali",
    delta_time: "Delta tempo B − A (s) · base tempo giro A",
    delta_time_multi: "Delta tempo vs A (s) · B rosso, C azzurro",
    track_map: "Mappa giro A",
    nav_tracks: "Piste",
    nav_weather: "Meteo",
    wx_title: "Meteo pista",
    wx_now: "Adesso",
    wx_now_short: "Ora",
    wx_feels: "Percepita",
    wx_humidity: "Umidità",
    wx_wind: "Vento",
    wx_gust: "Raffiche",
    wx_rain_1h: "Pioggia ultima ora",
    wx_dew: "Punto di rugiada",
    wx_pressure: "Pressione",
    wx_clouds: "Nuvolosità",
    wx_visibility: "Visibilità",
    wx_sunrise: "Alba",
    wx_sunset: "Tramonto",
    wx_rain: "Pioggia",
    wx_next_60: "Pioggia prossimi 60 minuti (mm/h)",
    wx_next_24h: "Prossime 24 ore",
    wx_next_days: "Prossimi giorni",
    wx_today: "Oggi",
    wx_radar: "Radar e previsione animata",
    wx_layer_radar: "Radar",
    wx_layer_rain: "Previsione pioggia",
    wx_layer_wind: "Vento",
    wx_rain_in: "Pioggia tra {m} minuti",
    wx_raining: "Pioggia in corso",
    wx_stop_in: "Fine prevista tra {m} minuti",
    wx_rain_continues: "Continua per tutta la prossima ora",
    wx_no_rain: "Nessuna pioggia in arrivo",
    wx_no_rain_sub: "Asciutto nei prossimi 60' · rischio basso fino a 120'",
    wx_rain_possible: "Possibile pioggia tra ~{m} minuti",
    wx_rain_prob: "Probabilità {p}%",
    wx_open: "Apri meteo",
    wx_no_minutely: "Previsione al minuto non disponibile qui",
    wx_int_light: "Debole",
    wx_int_moderate: "Moderata",
    wx_int_heavy: "Forte",
    wx_enable_notify: "Attiva notifiche",
    wx_notify_on: "Notifiche attive",
    wx_sound: "Segnale sonoro",
    wx_auto_live: "Pista LIVE",
    wx_pick_track: "Scegli pista",
    wx_search: "Cerca località…",
    wx_no_live: "Nessun evento LIVE oggi: scegli una pista o cerca una località.",
    wx_refresh: "Aggiorna",
    wx_fullscreen: "Schermo intero",
    wx_exit_fs: "Esci",
    wx_updated: "Aggiornato alle",
    wx_alert_from: "Dal",
    wx_windy_map: "Mappa Windy",
    wx_rain_map: "Radar ultimi 120 minuti e previsione 60 minuti",
    wx_on_track: "In pista",
    wx_map_step: "Previsione a passi di 3 ore",
    wx_kind_radar: "Radar",
    wx_kind_fc: "Previsione",
    wx_fc_unavailable: "Previsione non disponibile al momento, riprovo tra poco",
    wx_owm_usage: "richieste OpenWeather oggi {n}/{cap}",
    wx_maps_locked: "La previsione sulla mappa non è ancora attiva: abilita il piano Weather Maps 2.0 sul tuo account OpenWeather. Intanto vedi la pioggia attuale.",
    wx_alerts_active: "avvisi meteo attivi",
    wx_alert_to: "al",
    tracks_title: "Database piste",
    tracks_sub: "Piste kart con coordinate per la mappa satellitare in telemetria",
    new_track: "Nuova pista",
    edit_track: "Modifica pista",
    track_dialog_hint: "Cerca la pista o clicca sulla mappa per impostare il centro. Gli alias servono per l'abbinamento automatico col campo Track del CSV.",
    city: "Città",
    track_length: "Lunghezza (m)",
    aliases: "Alias (es. 7LAGHI)",
    search_place: "Cerca luogo...",
    search_track: "Cerca pista, città, nazione...",
    click_to_set_center: "Clicca sulla mappa per impostare le coordinate del centro pista.",
    no_coords: "Coordinate mancanti",
    aligned: "Allineata",
    color_speed: "Velocità",
    color_glat: "G laterale",
    color_glon: "G longitudinale",
    align: "Allinea",
    auto_align: "Auto",
    auto_aligning: "Allineo...",
    auto_align_saved: "Telemetria allineata automaticamente alla pista e salvata",
    auto_align_check: "Allineamento automatico applicato ma incerto: verifica, correggi e salva",
    auto_align_none: "Tracciato della pista non trovato su OpenStreetMap: usa l'allineamento manuale",
    auto_align_failed: "Servizio OpenStreetMap non raggiungibile: riprova o allinea manualmente",
    rotation: "Rotazione",
    scale: "Scala",
    move_1m: "Sposta 1 m",
    mirror: "Specchia",
    place_here: "Posiziona qui",
    click_on_map: "Clicca sulla mappa",
    reset: "Reset",
    save_alignment: "Salva allineamento",
    alignment_saved: "Allineamento salvato sulla pista",
    map_no_track_hint: "Seleziona una pista con coordinate per la mappa satellitare →",
    gps_absolute: "GPS lat/lon dal file",
    change_track: "Cambia pista",
    track_not_detected: "Pista non rilevata dal CSV: selezionala o cercala",
    from_database: "Database",
    search_track_or_address: "Cerca per nome pista o indirizzo...",
    no_results: "Nessun risultato",
    track_created: "Nuova pista creata e associata alla sessione",
    partial: "parziale",
    nav_drivers: "Piloti",
    nav_settings: "Setup utente",
    settings_title: "Setup utente",
    settings_sub: "Team, logo e preferenze dell'interfaccia",
    team: "Team",
    team_name: "Nome team",
    team_logo: "Logo team",
    upload: "Carica",
    remove: "Rimuovi",
    file_none: "Nessun file",
    hidden_event_types: "Nascondi tipologie gara",
    hidden_types_hint: "Clicca per nascondere: le tipologie barrate non saranno proposte in moduli e filtri.",
    hide_categories: "Nascondi categorie",
    hide_categories_hint: "Nasconde i campi categoria in eventi, sessioni, piloti e analisi.",
    team_notes: "Note importanti team",
    drivers_title: "Piloti",
    drivers_sub: "Anagrafica piloti da aggiungere agli eventi",
    new_driver: "Nuovo pilota",
    edit_driver: "Modifica pilota",
    personal: "Dati personali",
    first_name: "Nome",
    photo: "Foto",
    last_name: "Cognome",
    address: "Indirizzo",
    contacts: "Dati di contatto",
    phone: "Telefono",
    social: "Account social",
    birth_date: "Data di nascita",
    documents: "Documenti",
    license: "Licenza",
    license_number: "Licenza n°",
    medical: "Visita medica",
    medical_date: "Data visita medica",
    medical_expiry: "Scadenza visita medica",
    chassis_notes: "Info per misure telaio",
    misc_notes: "Note varie",
    no_drivers: "Nessun pilota. Aggiungine uno.",
    medical_expired: "Visita scaduta",
    medical_expiring: "In scadenza",
    medical_ok: "Visita valida",
    medical_alert_title: "Visite mediche da rinnovare",
    registry_drivers: "Piloti predefiniti · clicca per aggiungere",
    import_csv: "Importa CSV giri",
    replace_csv: "Sostituisci",
    laps_import_hint: "Carica il file LapTable (CSV) esportato dal sistema di acquisizione dati.",
    laps_imported: "Giri importati: miglior tempo e n° giri aggiornati dal file.",
    theoretical: "Teorico",
    average: "Media",
    consistency: "Costanza",
    valid_laps: "Giri validi",
    lap_col: "Giro",
    time_col: "Tempo",
    gap_best: "Δ best",
    chart_laps: "Andamento giri",
    show_param: "Parametro",
    no_valid_laps: "Nessun giro valido nel file.",
    setup_general: "Generale",
    session_notes: "Note sessione",
    g_rims: "Tipo cerchi",
    g_front_hubs: "Tipo mozzi ant.",
    g_rear_hubs: "Tipo mozzi post.",
    no_driver: "Senza pilota",
    tyre_sets: "Set gomme",
    tyre_set: "Set gomme",
    new_tyre_set: "Nuovo set",
    edit_tyre_set: "Modifica set",
    set_name: "Nome set",
    set_name_hint: "es. Set A, Nuove sabato",
    barcode: "Barcode",
    tyre_group: "Raggruppamento set",
    circumference: "Circonferenza",
    weight: "Peso",
    hardness: "Durezza",
    laps: "Giri",
    laps_short: "giri",
    total_laps: "Giri totali",
    scan_title: "Leggi barcode",
    scan_hint: "Inquadra il barcode della gomma oppure inserisci il codice (anche con lettore USB/Bluetooth).",
    camera_error: "Fotocamera non disponibile: inserisci il codice manualmente.",
    barcode_not_found: "Nessun set con questo barcode",
    tyre_set_found: "Set trovato",
    search_barcode: "Cerca o scansiona barcode",
    search_set: "Cerca per nome set",
    no_tyre_sets: "Nessun set gomme.",
    no_tyre_sets_event: "Nessun set gomme per questo evento. Creane uno.",
    tyres_archive_title: "Archivio gomme",
    tyres_archive_sub: "Tutti i set gomme con i giri percorsi. Cerca anche leggendo il barcode di una gomma.",
    usage_history: "Storico utilizzo",
    no_usage: "Set non ancora montato in nessuna sessione.",
    this_event: "Questo evento",
    other_events: "Altri eventi",
    confirm_tyre_set: "Il set verrà eliminato e rimosso dalle sessioni in cui è montato.",
    position: "Posizione",
    stint: "Stint",
    ok: "OK",
    setup: "Setup",
    pit: "PIT",
    pit_hint: "Cambio gomme: due stint con gomme, pressioni e miglior tempo separati",
    stint1: "Stint 1",
    stint2: "Stint 2",
    best_lap_s1: "Miglior tempo · Stint 1",
    best_lap_s2: "Miglior tempo · Stint 2",
    cold_group: "Pressioni a freddo",
    hot_group: "Pressioni a caldo",
    yes: "Sì",
    no: "No",
    tyres: "Gomme",
    front: "Anteriore",
    rear: "Posteriore",
    gear: "Rapporto",
    cold_in: "Ingresso (freddo)",
    hot_out: "Uscita (caldo)",
    cold_short: "IN",
    hot_short: "OUT",
    delta: "Delta",
    unit: "Unità",
    f_height: "Altezza",
    f_camber: "Camber",
    f_toe: "Convergenza",
    f_caster: "Caster",
    f_bar: "Barra",
    f_column: "Piantone",
    f_column_mount: "Montaggio piantone",
    f_width: "Larghezza",
    r_height: "Altezza",
    r_axle: "Assale",
    r_width: "Larghezza",
    r_seat_supports: "Supporti sedile",
    r_seat_height: "Altezza sedile",
    r_seat_type: "Tipo sedile",
    sprocket: "Corona",
    pinion: "Pignone",
    ratio: "Rapporto",
    tyre_fl: "Ant. Sx",
    tyre_fr: "Ant. Dx",
    tyre_rl: "Post. Sx",
    tyre_rr: "Post. Dx",
    garage_title: "Garage",
    garage_sub: "Anagrafica motori e telai da usare nelle sessioni",
    engines: "Motori",
    chassis_plural: "Telai",
    add: "Aggiungi",
    new_item: "Nuovo elemento",
    edit_item: "Modifica elemento",
    brand: "Marca",
    model: "Modello",
    serial: "Matricola / N. serie",
    no_items: "Nessun elemento. Aggiungine uno.",
    required: "Campo obbligatorio",
    garage_empty_hint: "Aggiungi motori e telai nel Garage per selezionarli qui.",
    type_FIA: "FIA",
    type_COTF: "COTF",
    type_WSK: "WSK",
    type_NATIONAL: "Campionato Nazionale",
    type_REGIONAL: "Regionale",
    type_ONE_MAKE: "Monomarca",
    type_TROPHY: "Trofeo",
    type_TEST: "Test / Prove",
    type_OTHER: "Altro",
    conditions: "Condizioni pista",
    weather: "Meteo",
    air_temp: "Temp. aria (°C)",
    track_temp: "Temp. asfalto (°C)",
    air_short: "Aria",
    humidity_pct: "Umidità (%)",
    wind_kmh: "Vento (km/h)",
    wind_dir: "Provenienza vento",
    pressure_hpa: "Pressione (hPa)",
    use_live_weather: "Usa meteo attuale",
    weather_filled: "Meteo compilato dalla pista LIVE",
    weather_from: "Dal meteo di {track} alle {time}",
    no_track_coords: "La pista dell'evento non ha coordinate: impossibile leggere il meteo",
    hum_short: "Umid.",
    wind_short: "Vento",
    track_short: "Asfalto",
    weather_sunny: "Sereno",
    weather_partly_cloudy: "Poco nuvoloso",
    weather_cloudy: "Nuvoloso",
    weather_drizzle: "Pioviggine",
    weather_rain: "Pioggia",
    weather_mixed: "Variabile",
    nav_compare: "Confronto",
    nav_telemetry: "Telemetria",
    telemetry_compare_title: "Confronto telemetria",
    telemetry_compare_sub: "Confronta giri di qualsiasi sessione e pilota sulla stessa pista",
    telemetry_compare_empty: "Nessuna telemetria importata con pista riconosciuta.",
    all_drivers: "Tutti i piloti",
    lap_a: "Giro A",
    lap_b: "Giro B",
    lap_c: "Giro C (opzionale)",
    best_session: "sessione migliore",
    load_best_a: "Best → Giro A",
    best_loaded: "Best caricato in A",
    driver_best_b: "Best pilota → Giro B",
    pick_session: "Scegli sessione...",
    compare_pick_hint: "Scegli almeno il giro A per iniziare l'analisi.",
    compare_other_session: "Confronta con altra sessione",
    lap_b_other_session: "Giro B da altra sessione (stessa pista)",
    no_other_sessions_track: "Nessuna altra sessione con telemetria su questa pista.",
    x_axis: "Asse X",
    axis_time: "Tempo",
    axis_distance: "Distanza",
    zoom_reset: "Reset zoom",
    zoom_hint: "Trascina su un grafico per ingrandire · doppio clic per tornare",
    stats: "Statistiche",
    lap_time: "Tempo giro",
    speed_max: "Velocità max",
    speed_min: "Velocità min",
    rpm_max: "RPM max",
    rpm_min: "RPM min",
    glat_max: "G Lat Max",
    glon_acc: "G Long Acc",
    glon_brake: "G Long Brake",
    sectors_hint: "Settori non disponibili: importa il CSV tabella giri (con Settore 1..n) nella scheda Giri.",
    fullscreen: "Schermo intero",
    exit_fullscreen: "Riduci",
    telemetry_fullscreen: "Telemetria full screen",
    exit_fullscreen_esc: "Esci · Esc",
    analysis: "Analisi",
    onboard_3d: "Onboard 3D",
    cam_onboard: "Onboard",
    cam_chase: "Camera TV",
    onboard_aligned: "Allineato alla pista reale",
    onboard_local: "Coordinate locali",
    compare: "Confronta",
    compare_title: "Confronto sessioni",
    compare_sub: "Due sessioni affiancate: le differenze sono evidenziate",
    session_a: "Sessione A",
    session_b: "Sessione B",
    select_event: "Seleziona evento",
    select_session: "Seleziona sessione",
    parameter: "Parametro",
    difference: "Δ B−A",
    only_diff: "Solo differenze",
    compare_empty: "Seleziona due sessioni da confrontare.",
    no_diff: "Nessuna differenza in questa sezione.",
    categories: "Categorie",
    drivers: "Piloti",
    driver: "Pilota",
    tag_hint: "Scrivi e premi Invio",
    event_lists_hint: "Aggiungi piloti e categorie all'evento per selezionarli qui.",
    all_drivers: "Tutti i piloti",
    all_categories: "Tutte le categorie",
    nav_pressures: "Pressioni",
    pressures_title: "Pressioni vs temperatura",
    pressures_sub: "Pressioni a caldo rispetto alla temperatura dell'asfalto, sessioni sulla stessa pista",
    select_track: "Seleziona pista",
    all_tyres: "Tutte le gomme",
    pressure_hot: "Pressione a caldo",
    excluded_note: "sessioni escluse (manca temperatura asfalto o pressione a caldo)",
    no_points: "Nessun dato: registra sessioni con temperatura asfalto e pressioni a caldo su questa pista.",
    no_tracks: "Nessuna pista: crea prima un evento.",
    trend: "Linea di tendenza",
    event: "Evento",
  },
  en: {
    app_name: "Kart Setup & Data Analisys by RacingDreams",
    claim: "Setup, Pressures, Data Analysis",
    tagline: "Everything you need to improve every day in Motorsport, in a single app born from our many years of experience in FIA Karting championships.",
    nav_events: "Events",
    nav_garage: "Garage",
    g_laps: "Total laps",
    tyre_brand: "Tyre brand",
    tyre_model: "Model / compound",
    tyre_target: "Exit target",
    tyre_unknown: "Tyre not set",
    tyre_targets: "Exit pressure targets",
    tyre_targets_hint: "Hot pressure to reach at exit per tyre brand and model (bar). Tolerance defines the 'on target' band.",
    default_channels: "Default telemetry charts",
    default_channels_hint: "Channels shown when telemetry analysis opens. You can still toggle others in the analysis. No selection = speed and RPM.",
    no_channels_yet: "Import a telemetry file to see the available channels.",
    target_bar: "Target (bar)",
    tolerance_bar: "Tol. ± (bar)",
    add_target: "Add tyre",
    no_target: "No target for this tyre: set brand and model and define its target in Settings.",
    no_target_short: "Target not set",
    tyre_from_set: "From tyre set",
    tyre_from_set_hint: "Brand and model come from the selected set: edit the set in the garage or pick None to change them",
    p_ok: "On target",
    p_high: "High",
    p_low: "Low",
    p_mixed: "Mixed",
    p_na: "—",
    p_na_hot: "No hot data",
    pa_title: "Pressure analysis",
    pa_next: "Advice for the next session",
    pa_exp_temp: "Expected track (°C)",
    pa_cold_next: "Suggested cold",
    pa_delta: "Δ target",
    pa_gain: "Gain",
    pa_based: "Temperature correction from history ({n} stints same track and tyre, avg {s}/°C).",
    calc_air_ignored: "Air temperature has no effect: not enough air variation in sessions.",
    calc_track_ignored: "Track temperature has no effect: not enough track variation in sessions.",
    calc_temps_ignored: "Temperatures have no effect: too few sessions or similar conditions, using mean.",
    pa_no_hist: "Not enough history to estimate the track temperature effect: advice uses this session's cold→hot gain.",
    tip_all_ok: "All wheels on target: in similar conditions repeat the same cold pressures.",
    tip_wheel: "{w}: exit {d} {u} vs target → cold {c} {u}.",
    tip_axle_front: "Fronts higher than rears by {d} {u} at exit: correct axles separately.",
    tip_axle_rear: "Rears higher than fronts by {d} {u} at exit: correct axles separately.",
    tip_side_left: "Left side higher than right by {d} {u}: typical with mostly right-hand corners, adjust single wheels.",
    tip_side_right: "Right side higher than left by {d} {u}: typical with mostly left-hand corners, adjust single wheels.",
    tip_temp: "Advice computed for track at {t}°C ({d}°C vs this session).",
    tip_missing_hot: "Enter exit hot pressures to get analysis and advice.",
    tyre_model_filter: "Tyre",
    all_tyre_models: "All tyres (brand)",
    hot_vs_target: "Exit pressure vs target",
    gain_chart: "Cold → hot gain vs {x}",
    calc_title: "Cold pressure calculator",
    calc_hint: "Suggested cold = target − expected gain at the given track temp (regression on filtered stints; needs 3+ stints over 4°C range, otherwise mean).",
    calc_need_model: "Select a tyre with a target to use the calculator.",
    pick_model_note: "Different tyres in data: select a tyre to see the target band.",
    in_target_rate: "Stints on target",
    avg_delta: "Avg Δ",
    status: "Status",
    avg_delta_wheel: "Average Δ vs target per wheel",
    sec_summary: "Summary",
    sec_charts: "Charts",
    impact_title: "Conditions influence",
    impact_hint: "Average change of the hot gain (hot − cold, mean of 4 tyres) as each condition changes, over the filtered sessions. Click a card to use it as the charts' X axis.",
    impact_per: "gain per +{s}",
    impact_strong: "Strong influence",
    impact_moderate: "Moderate influence",
    impact_weak: "Weak influence",
    impact_none: "Negligible",
    impact_few: "Not enough data (n={n}, at least 3 sessions needed)",
    impact_flat: "Same value in all filtered sessions",
    sec_sessions: "Analysed sessions",
    calc_scope: "Data basis",
    analysis_period: "Analysis period (required)",
    days_filter: "Days",
    all_days: "All event days",
    days_selected: "days selected",
    pick_event: "Select event…",
    need_event: "Select at least one event (and optionally days) to narrow the analysis period.",
    calc_basis: "Based on the {n} sessions of the selected period (events/days in filters).",
    calc_scope_all: "All filtered history",
    calc_scope_event: "Same event",
    calc_scope_day: "Same event and day",
    calc_day: "Day",
    air_temp_short: "Current air (°C)",
    track_temp_short: "Current track (°C)",
    calc_no_data: "No session with cold and hot pressures for this selection.",
    calc_model: "Model",
    model_both: "Air + track regression",
    model_track: "Track regression",
    model_air: "Air regression",
    model_mean: "Mean cold→hot gain",
    calc_hint2: "Suggested cold = target − expected gain at the given temperatures, estimated from the selected sessions (3-4 sessions with different temperatures needed for regression, otherwise mean).",
    calc_used: "Sessions used (air / track)",
    vs_last: "vs last",
    lapfile_add: "Add lap file",
    lapfile_replace: "Replace lap file",
    lapfile_hint: "Add the lap file (CSV with lap and sector times) to compute the theoretical lap and sectors.",
    lapfile_done: "Lap file imported: sectors and theoretical updated.",
    lapfile_no_sectors: "no sectors in file",
    lapfile_match: "{m}/{n} laps consistent with telemetry.",
    lapfile_force: "Import anyway",
    qi_btn: "Quick import",
    qi_title: "Quick telemetry import",
    qi_base: "Session name",
    qi_base_hint: "Sessions will be created as {n}1, {n}2, … ordered by telemetry date and time.",
    qi_pick: "Select one or more telemetry CSV files",
    qi_files: "files selected · click to change",
    qi_run: "Import and create sessions",
    qi_created: "sessions created",
    qi_close: "Close",
    all_events: "All events",
    events_filter: "Event / Events",
    events_selected: "events selected",
    gmaps_link: "Create from Google Maps",
    gmaps_import: "Import",
    gmaps_done: "Location imported from Google Maps",
    gmaps_hint: "On Google Maps: Share → Copy link, or right-click the track → click the coordinates to copy them.",
    g_sessions: "Sessions",
    g_events: "Events",
    g_last_used: "Last used",
    g_laps_reset: "Laps since reset",
    g_hours: "Engine hours",
    logout: "Logout",
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    sign_in: "Sign in",
    create_account: "Create account",
    or: "or",
    google: "Continue with Google",
    loading: "Loading...",
    events_title: "Event calendar",
    events_sub: "Your races in calendar order",
    new_event: "New event",
    edit_event: "Edit event",
    search_name: "Search by event name",
    track: "Track",
    event_type: "Type",
    all_types: "All types",
    date_from: "From",
    date_to: "To",
    reset_filters: "Reset filters",
    order_asc: "Oldest first",
    order_desc: "Newest first",
    no_events: "No events found. Create your first event.",
    sessions_count: "sessions",
    laps_per_driver: "Laps per driver",
    hour_meter: "Last hour meter reading (h)",
    hour_meter_date: "Reading date",
    carburetor: "Installed carburetor",
    ignition: "Installed ignition",
    engine_setup: "Engine setup (notes)",
    maintenance: "Maintenance",
    maintenance_short: "maintenance",
    add_maintenance: "Add",
    no_maintenance: "No maintenance recorded",
    activity: "Activity",
    cost_eur: "Cost €",
    reset_hours: "Hour reset",
    last_reset: "last reset",
    event_best: "Event best",
    total: "Total",
    country: "Country",
    category: "Category",
    category_hint: "e.g. OK, KZ2, X30 Senior",
    event_name: "Event name",
    start_date: "Start date",
    end_date: "End date",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    duplicate: "Duplicate",
    back: "Back",
    confirm_title: "Confirm deletion?",
    confirm_event: "The event and all its sessions will be permanently deleted.",
    confirm_generic: "This item will be permanently deleted.",
    saved: "Saved",
    deleted: "Deleted",
    sessions: "Sessions",
    new_session: "New session",
    edit_session: "Edit session",
    no_sessions: "No sessions recorded for this event.",
    session_name: "Session name",
    session_name_hint: "e.g. Free practice 1, Qualifying, Final",
    session_date: "Session date",
    session_time: "Time",
    best_lap: "Best lap",
    best_lap_hint: "e.g. 48.235 or 1:02.481",
    event_best: "Event best lap",
    chassis: "Chassis",
    engine: "Engine",
    none: "None",
    general: "General",
    nav_tyres: "Tyres",
    telemetry: "Telemetry",
    telemetry_hint: "Upload the session CSV exported from MAAT (Tools → Export CSV → Whole session).",
    telemetry_save_first: "Press Save: the session is created and you stay here to import telemetry right away.",
    session_created_telemetry: "Session created: you can now import telemetry",
    telemetry_imported: "Telemetry imported",
    telemetry_imported_laps: "Telemetry imported: Laps tab, best lap and lap count generated automatically.",
    import_telemetry: "Import telemetry",
    processing: "Processing...",
    channels: "Channels",
    delta_time: "Time delta B − A (s) · lap A time base",
    delta_time_multi: "Time delta vs A (s) · B red, C cyan",
    track_map: "Lap A map",
    nav_tracks: "Tracks",
    nav_weather: "Weather",
    wx_title: "Track weather",
    wx_now: "Now",
    wx_now_short: "Now",
    wx_feels: "Feels like",
    wx_humidity: "Humidity",
    wx_wind: "Wind",
    wx_gust: "Gusts",
    wx_rain_1h: "Rain last hour",
    wx_dew: "Dew point",
    wx_pressure: "Pressure",
    wx_clouds: "Cloud cover",
    wx_visibility: "Visibility",
    wx_sunrise: "Sunrise",
    wx_sunset: "Sunset",
    wx_rain: "Rain",
    wx_next_60: "Rain next 60 minutes (mm/h)",
    wx_next_24h: "Next 24 hours",
    wx_next_days: "Next days",
    wx_today: "Today",
    wx_radar: "Radar and animated forecast",
    wx_layer_radar: "Radar",
    wx_layer_rain: "Rain forecast",
    wx_layer_wind: "Wind",
    wx_rain_in: "Rain in {m} minutes",
    wx_raining: "Raining now",
    wx_stop_in: "Expected to stop in {m} minutes",
    wx_rain_continues: "Continues for the whole next hour",
    wx_no_rain: "No rain incoming",
    wx_no_rain_sub: "Dry for the next 60' · low risk up to 120'",
    wx_rain_possible: "Possible rain in ~{m} minutes",
    wx_rain_prob: "Probability {p}%",
    wx_open: "Open weather",
    wx_no_minutely: "Minute forecast not available here",
    wx_int_light: "Light",
    wx_int_moderate: "Moderate",
    wx_int_heavy: "Heavy",
    wx_enable_notify: "Enable notifications",
    wx_notify_on: "Notifications on",
    wx_sound: "Sound alert",
    wx_auto_live: "LIVE track",
    wx_pick_track: "Pick track",
    wx_search: "Search place…",
    wx_no_live: "No LIVE event today: pick a track or search a place.",
    wx_refresh: "Refresh",
    wx_fullscreen: "Full screen",
    wx_exit_fs: "Exit",
    wx_updated: "Updated at",
    wx_alert_from: "From",
    wx_windy_map: "Windy map",
    wx_rain_map: "Radar last 120 minutes and 60-minute forecast",
    wx_on_track: "At track",
    wx_map_step: "Forecast in 3-hour steps",
    wx_kind_radar: "Radar",
    wx_kind_fc: "Forecast",
    wx_fc_unavailable: "Forecast unavailable right now, retrying shortly",
    wx_owm_usage: "OpenWeather calls today {n}/{cap}",
    wx_maps_locked: "Map forecast not active yet: enable the Weather Maps 2.0 plan on your OpenWeather account. Showing current rain meanwhile.",
    wx_alerts_active: "active weather alerts",
    wx_alert_to: "to",
    tracks_title: "Track database",
    tracks_sub: "Kart tracks with coordinates for the telemetry satellite map",
    new_track: "New track",
    edit_track: "Edit track",
    track_dialog_hint: "Search the track or click the map to set its center. Aliases are used to auto-match the CSV Track field.",
    city: "City",
    track_length: "Length (m)",
    aliases: "Aliases (e.g. 7LAGHI)",
    search_place: "Search place...",
    search_track: "Search track, city, country...",
    click_to_set_center: "Click the map to set the track center coordinates.",
    no_coords: "Missing coordinates",
    aligned: "Aligned",
    color_speed: "Speed",
    color_glat: "Lateral G",
    color_glon: "Longitudinal G",
    align: "Align",
    auto_align: "Auto",
    auto_aligning: "Aligning...",
    auto_align_saved: "Telemetry automatically aligned to the track and saved",
    auto_align_check: "Automatic alignment applied but uncertain: check, adjust and save",
    auto_align_none: "Track layout not found on OpenStreetMap: use manual alignment",
    auto_align_failed: "OpenStreetMap service unreachable: retry or align manually",
    rotation: "Rotation",
    scale: "Scale",
    move_1m: "Move 1 m",
    mirror: "Mirror",
    place_here: "Place here",
    click_on_map: "Click on the map",
    reset: "Reset",
    save_alignment: "Save alignment",
    alignment_saved: "Alignment saved on track",
    map_no_track_hint: "Select a track with coordinates for the satellite map →",
    gps_absolute: "GPS lat/lon from file",
    change_track: "Change track",
    track_not_detected: "Track not detected from CSV: select or search it",
    from_database: "Database",
    search_track_or_address: "Search by track name or address...",
    no_results: "No results",
    track_created: "New track created and linked to the session",
    partial: "partial",
    nav_drivers: "Drivers",
    nav_settings: "User setup",
    settings_title: "User setup",
    settings_sub: "Team, logo and interface preferences",
    team: "Team",
    team_name: "Team name",
    team_logo: "Team logo",
    upload: "Upload",
    remove: "Remove",
    file_none: "No file",
    hidden_event_types: "Hide event types",
    hidden_types_hint: "Click to hide: struck-through types won't be offered in forms and filters.",
    hide_categories: "Hide categories",
    hide_categories_hint: "Hides category fields in events, sessions, drivers and analysis.",
    team_notes: "Important team notes",
    drivers_title: "Drivers",
    drivers_sub: "Driver registry to add to events",
    new_driver: "New driver",
    edit_driver: "Edit driver",
    personal: "Personal data",
    first_name: "First name",
    photo: "Photo",
    last_name: "Last name",
    address: "Address",
    contacts: "Contact details",
    phone: "Phone",
    social: "Social account",
    birth_date: "Date of birth",
    documents: "Documents",
    license: "Licence",
    license_number: "Licence no.",
    medical: "Medical exam",
    medical_date: "Medical exam date",
    medical_expiry: "Medical expiry",
    chassis_notes: "Chassis measurement info",
    misc_notes: "Other notes",
    no_drivers: "No drivers yet. Add one.",
    medical_expired: "Medical expired",
    medical_expiring: "Expiring soon",
    medical_ok: "Medical valid",
    medical_alert_title: "Medical exams to renew",
    registry_drivers: "Saved drivers · click to add",
    import_csv: "Import lap CSV",
    replace_csv: "Replace",
    laps_import_hint: "Upload the LapTable (CSV) file exported from your data logger.",
    laps_imported: "Laps imported: best lap and lap count updated from the file.",
    theoretical: "Theoretical",
    average: "Average",
    consistency: "Consistency",
    valid_laps: "Valid laps",
    lap_col: "Lap",
    time_col: "Time",
    gap_best: "Δ best",
    chart_laps: "Lap trend",
    show_param: "Parameter",
    no_valid_laps: "No valid laps in file.",
    setup_general: "General",
    session_notes: "Session notes",
    g_rims: "Rim type",
    g_front_hubs: "Front hub type",
    g_rear_hubs: "Rear hub type",
    no_driver: "No driver",
    tyre_sets: "Tyre sets",
    tyre_set: "Tyre set",
    new_tyre_set: "New set",
    edit_tyre_set: "Edit set",
    set_name: "Set name",
    set_name_hint: "e.g. Set A, New Saturday",
    barcode: "Barcode",
    tyre_group: "Set grouping",
    circumference: "Circumference",
    weight: "Weight",
    hardness: "Hardness",
    laps: "Laps",
    laps_short: "laps",
    total_laps: "Total laps",
    scan_title: "Scan barcode",
    scan_hint: "Point the camera at the tyre barcode or type the code (USB/Bluetooth scanners work too).",
    camera_error: "Camera not available: enter the code manually.",
    barcode_not_found: "No set with this barcode",
    tyre_set_found: "Set found",
    search_barcode: "Search or scan barcode",
    search_set: "Search by set name",
    no_tyre_sets: "No tyre sets.",
    no_tyre_sets_event: "No tyre sets for this event. Create one.",
    tyres_archive_title: "Tyre archive",
    tyres_archive_sub: "All tyre sets with laps covered. Search by scanning a tyre barcode too.",
    usage_history: "Usage history",
    no_usage: "Set not mounted in any session yet.",
    this_event: "This event",
    other_events: "Other events",
    confirm_tyre_set: "The set will be deleted and removed from the sessions where it is mounted.",
    position: "Position",
    stint: "Stint",
    ok: "OK",
    setup: "Setup",
    pit: "PIT",
    pit_hint: "Tyre change: two stints with separate tyres, pressures and best lap",
    stint1: "Stint 1",
    stint2: "Stint 2",
    best_lap_s1: "Best lap · Stint 1",
    best_lap_s2: "Best lap · Stint 2",
    cold_group: "Cold pressures",
    hot_group: "Hot pressures",
    yes: "Yes",
    no: "No",
    tyres: "Tyres",
    front: "Front",
    rear: "Rear",
    gear: "Gearing",
    cold_in: "In (cold)",
    hot_out: "Out (hot)",
    cold_short: "IN",
    hot_short: "OUT",
    delta: "Delta",
    unit: "Unit",
    f_height: "Height",
    f_camber: "Camber",
    f_toe: "Toe",
    f_caster: "Caster",
    f_bar: "Bar",
    f_column: "Steering column",
    f_column_mount: "Column mounting",
    f_width: "Width",
    r_height: "Height",
    r_axle: "Axle",
    r_width: "Width",
    r_seat_supports: "Seat supports",
    r_seat_height: "Seat height",
    r_seat_type: "Seat type",
    sprocket: "Sprocket",
    pinion: "Pinion",
    ratio: "Ratio",
    tyre_fl: "Front L",
    tyre_fr: "Front R",
    tyre_rl: "Rear L",
    tyre_rr: "Rear R",
    garage_title: "Garage",
    garage_sub: "Engine and chassis registry for your sessions",
    engines: "Engines",
    chassis_plural: "Chassis",
    add: "Add",
    new_item: "New item",
    edit_item: "Edit item",
    brand: "Brand",
    model: "Model",
    serial: "Serial number",
    no_items: "No items yet. Add one.",
    required: "Required field",
    garage_empty_hint: "Add engines and chassis in the Garage to select them here.",
    type_FIA: "FIA",
    type_COTF: "COTF",
    type_WSK: "WSK",
    type_NATIONAL: "National Championship",
    type_REGIONAL: "Regional",
    type_ONE_MAKE: "One-make",
    type_TROPHY: "Trophy",
    type_TEST: "Test / Practice",
    type_OTHER: "Other",
    conditions: "Track conditions",
    weather: "Weather",
    air_temp: "Air temp (°C)",
    track_temp: "Track temp (°C)",
    air_short: "Air",
    humidity_pct: "Humidity (%)",
    wind_kmh: "Wind (km/h)",
    wind_dir: "Wind from",
    pressure_hpa: "Pressure (hPa)",
    use_live_weather: "Use current weather",
    weather_filled: "Weather filled from the LIVE track",
    weather_from: "From {track} weather at {time}",
    no_track_coords: "The event track has no coordinates: cannot read the weather",
    hum_short: "Hum.",
    wind_short: "Wind",
    track_short: "Track",
    weather_sunny: "Sunny",
    weather_partly_cloudy: "Partly cloudy",
    weather_cloudy: "Cloudy",
    weather_drizzle: "Drizzle",
    weather_rain: "Rain",
    weather_mixed: "Mixed",
    nav_compare: "Compare",
    nav_telemetry: "Telemetry",
    telemetry_compare_title: "Telemetry comparison",
    telemetry_compare_sub: "Compare laps from any session and driver on the same track",
    telemetry_compare_empty: "No telemetry imported with a recognised track.",
    all_drivers: "All drivers",
    lap_a: "Lap A",
    lap_b: "Lap B",
    lap_c: "Lap C (optional)",
    best_session: "best session",
    load_best_a: "Best → Lap A",
    best_loaded: "Best loaded in A",
    driver_best_b: "Driver best → Lap B",
    pick_session: "Pick session...",
    compare_pick_hint: "Pick at least lap A to start the analysis.",
    compare_other_session: "Compare with another session",
    lap_b_other_session: "Lap B from another session (same track)",
    no_other_sessions_track: "No other session with telemetry on this track.",
    x_axis: "X axis",
    axis_time: "Time",
    axis_distance: "Distance",
    zoom_reset: "Reset zoom",
    zoom_hint: "Drag on a chart to zoom · double-click to reset",
    stats: "Statistics",
    lap_time: "Lap time",
    speed_max: "Max speed",
    speed_min: "Min speed",
    rpm_max: "Max RPM",
    rpm_min: "Min RPM",
    glat_max: "G Lat Max",
    glon_acc: "G Long Acc",
    glon_brake: "G Long Brake",
    sectors_hint: "Sectors unavailable: import the lap table CSV (with Sector 1..n) in the Laps tab.",
    fullscreen: "Full screen",
    exit_fullscreen: "Exit",
    telemetry_fullscreen: "Full screen telemetry",
    exit_fullscreen_esc: "Exit · Esc",
    analysis: "Analysis",
    onboard_3d: "Onboard 3D",
    cam_onboard: "Onboard",
    cam_chase: "TV camera",
    onboard_aligned: "Aligned to real track",
    onboard_local: "Local coordinates",
    compare: "Compare",
    compare_title: "Session comparison",
    compare_sub: "Two sessions side by side with differences highlighted",
    session_a: "Session A",
    session_b: "Session B",
    select_event: "Select event",
    select_session: "Select session",
    parameter: "Parameter",
    difference: "Δ B−A",
    only_diff: "Differences only",
    compare_empty: "Select two sessions to compare.",
    no_diff: "No differences in this section.",
    categories: "Categories",
    drivers: "Drivers",
    driver: "Driver",
    tag_hint: "Type and press Enter",
    event_lists_hint: "Add drivers and categories to the event to select them here.",
    all_drivers: "All drivers",
    all_categories: "All categories",
    nav_pressures: "Pressures",
    pressures_title: "Pressure vs temperature",
    pressures_sub: "Hot pressures against track temperature across sessions on the same track",
    select_track: "Select track",
    all_tyres: "All tyres",
    pressure_hot: "Hot pressure",
    excluded_note: "sessions excluded (missing track temp or hot pressure)",
    no_points: "No data: record sessions with track temperature and hot pressures on this track.",
    no_tracks: "No tracks yet: create an event first.",
    trend: "Trend line",
    event: "Event",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("kart_lang") || "it");
  const setLang = useCallback((l) => {
    localStorage.setItem("kart_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => dict[lang][key] ?? key, [lang]);
  return createElement(LangContext.Provider, { value: { lang, setLang, t } }, children);
}

export const useT = () => useContext(LangContext);
